

import {Component} from "@angular/core";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {
  title = 'Home';
}



// WEBPACK FOOTER //
// ./src/components/app/home/home.component.ts